import { ModuleRegisterContext, ModuleRegisterFn } from "@/module-register"

const moduleRegister: ModuleRegisterFn = (context: ModuleRegisterContext) => {
  console.log("clinic checkin module registered with context", context)
}

export default moduleRegister
